var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdpSolar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 48,
    rx: 8,
    width: 48
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#43b17e",
    height: 48,
    rx: 8,
    width: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z",
    fill: "#212e3e"
  }), /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "#26fe56",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.5826 13.0435c0-.2305.1869-.4174.4174-.4174s.4174.1869.4174.4174v4.6047c1.4436.0935 2.7562.6682 3.7787 1.5654l3.2562-3.2562c.163-.163.4273-.163.5903 0s.163.4273 0 .5903l-3.2562 3.2562c.8972 1.0226 1.4719 2.3351 1.5654 3.7787h4.6047c.2305 0 .4174.1869.4174.4174s-.1869.4174-.4174.4174h-4.6047c-.0935 1.4436-.6682 2.7561-1.5654 3.7787l3.2562 3.2562c.163.163.163.4273 0 .5903s-.4273.163-.5903 0l-3.2562-3.2562c-1.0225.8972-2.3351 1.4719-3.7787 1.5654v4.6047c0 .2305-.1869.4174-.4174.4174s-.4174-.1869-.4174-.4174v-4.6047c-1.4436-.0935-2.7561-.6682-3.7787-1.5654l-3.2562 3.2562c-.163.163-.4273.163-.5903 0s-.163-.4273 0-.5903l3.2562-3.2562c-.8972-1.0226-1.4719-2.3351-1.5653-3.7787h-4.6048c-.2305 0-.4174-.1869-.4174-.4174s.1869-.4174.4174-.4174h4.6048c.0934-1.4436.6681-2.7562 1.5653-3.7787l-3.2562-3.2562c-.163-.163-.163-.4273 0-.5903s.4273-.163.5903 0l3.2562 3.2562c1.0226-.8972 2.3351-1.4719 3.7787-1.5654zm.4174 16.4869c3.0544 0 5.5304-2.476 5.5304-5.5304s-2.476-5.5304-5.5304-5.5304-5.5304 2.476-5.5304 5.5304 2.476 5.5304 5.5304 5.5304z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.113 24c0 9.4513-7.6617 17.113-17.113 17.113s-17.11304-7.6617-17.11304-17.113 7.66174-17.11304 17.11304-17.11304 17.113 7.66174 17.113 17.11304zm-1.0434 0c0 8.875-7.1946 16.0696-16.0696 16.0696s-16.06956-7.1946-16.06956-16.0696 7.19456-16.06957 16.06956-16.06957 16.0696 7.19457 16.0696 16.06957z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdpSolar);
export default __webpack_public_path__ + "static/media/edp-solar.02e20f7316abd090ebb97aeaaa925b4a.svg";
export { ForwardRef as ReactComponent };